import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TransactionDescriptionService } from 'app/services/models/transaction-description.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-transaction-description-detail',
  templateUrl: './transaction-description-detail.component.html',
  styleUrls: ['./transaction-description-detail.component.scss'],
  encapsulation:ViewEncapsulation.None
})
export class TransactionDescriptionDetailComponent implements OnInit {
  public contentHeader: object;
  form:FormGroup;
  constructor(
    private fb: FormBuilder,
    private transactionDescription:TransactionDescriptionService,
    private toastrService:ToastrService,
    private activatedRouter:ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.contentHeader = {
      headerTitle: 'İşlem Açıklamaları',
      actionButton: true,
      breadcrumb: {
        type: '',
        links: [
          {
            name: 'Açıklama Listesi',
            isLink: true,
            link:'/transaction-description'
          },
          {
            name: 'Açıklama Güncelle',
            isLink: false,
          },
        ]
      }
    }
    this.activatedRouter.params.subscribe(async params=>{
      console.log(params);

      await this.getByIdTransactionDescription(params['id'])
    })
    this.form = this.fb.group({
      title: [null, [Validators.required, Validators.maxLength(250)]],
      description: [null,[Validators.required]]
    });
  }

  async getByIdTransactionDescription(id){
    const data = await this.transactionDescription.getByIdTransactionDescription(id);
    console.log(data);
    if(data){
      this.form.patchValue({
        title:data.title,
        description:data.description
      })
    }
  }


  async onSubmit(){
    console.log(this.form.value)
    const response = await this.transactionDescription.createTransactionDescription(this.form.value.title,this.form.value.description);
    if(response.status == true){
      this.toastrService.success(response.message);
      this.form.reset();
    }else{
      this.toastrService.error(response.message);
    }
  }
}
